export const ANNUAL = "0";
export const SEMI_ANNUAL = "1";
export const QUARTERLY = "2";
export const MONTHLY = "3";

export const PAYMENT_CHOICES = {
    [ANNUAL]: "Annual",
    [SEMI_ANNUAL]: "Semi-Annual",
    [QUARTERLY]: "Quarterly",
    [MONTHLY]: "Monthly",
}

export const UI_PAYMENT_VALUES = [
    ANNUAL,
    MONTHLY
];

export const ALL_PAYMENT_VALUES = [
    ANNUAL,
    SEMI_ANNUAL,
    QUARTERLY,
    MONTHLY
]

let upTo350k = [];  // 50k to 350k steps of 25k
for (let i = 50_000; i < 350_000; i += 25_000)
    upTo350k.push(i);

let upTo1M = []; // 350k to 1M steps of 50k
for (let i = 350_000; i < 1_000_000; i += 50_000)
    upTo1M.push(i);

let upTo2M = []; // 1M to 2M steps of 100k
for (let i = 1_000_000; i < 2_000_000; i += 100_000)
    upTo2M.push(i);

let upTo5M = []; // 2M to 5M steps of 250k
for (let i = 2_000_000; i < 5_000_000; i += 250_000)
    upTo5M.push(i);

let upTo10M = []; // 5M to 10M steps of 500k
for (let i = 5_000_000; i < 10_000_000; i += 500_000)
    upTo10M.push(i);

let upTo25M = []; // 10M to 25M steps of 5M
for (let i = 10_000_000; i <= 25_000_000; i += 5_000_000)
    upTo25M.push(i);

export const AMOUNT_VALUES = [
    ...upTo350k,
    ...upTo1M,
    ...upTo2M,
    ...upTo5M,
    ...upTo10M,
    ...upTo25M,
];
